module.exports = __webpack_public_path__ + "static/media/dashboard.230c51d5.svg";